import React, { useState } from 'react';
import { FaBitcoin, FaCreditCard, FaEthereum, FaLock, FaCheck } from 'react-icons/fa';
import { SiUsdc } from 'react-icons/si';
import { QRCodeSVG } from 'qrcode.react';
import '../App.css';

function PaymentPage() {
  const [paymentMethod, setPaymentMethod] = useState('crypto');
  const [selectedCrypto, setSelectedCrypto] = useState('btc');
  const [copySuccess, setCopySuccess] = useState(false);
  
  const cryptoAddresses = {
    btc: 'bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
    eth: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
    usdc: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e'
  };

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(cryptoAddresses[selectedCrypto]);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  return (
    <div className="container">
      <div className="app-header">
        <h1>Complete Payment</h1>
        <p className="subtitle">Choose your preferred payment method</p>
      </div>

      <div className="main-content">
        <div className="payment-method-selector">
          <button 
            className={`payment-method-button ${paymentMethod === 'crypto' ? 'active' : ''}`}
            onClick={() => setPaymentMethod('crypto')}
          >
            <FaBitcoin /> Crypto
          </button>
          <button 
            className={`payment-method-button ${paymentMethod === 'card' ? 'active' : ''}`}
            onClick={() => setPaymentMethod('card')}
          >
            <FaCreditCard /> Card
          </button>
        </div>

        {paymentMethod === 'crypto' ? (
          <div className="crypto-payment">
            <div className="input-group">
              <label className="input-label">Select Cryptocurrency</label>
              <select 
                className="select-input"
                value={selectedCrypto}
                onChange={(e) => setSelectedCrypto(e.target.value)}
              >
                <option value="btc">Bitcoin (BTC)</option>
                <option value="eth">Ethereum (ETH)</option>
                <option value="usdc">USDC</option>
              </select>
            </div>
            
            <div className="crypto-address">
              <label className="input-label">Send Payment To:</label>
              <div className="address-display">
                {cryptoAddresses[selectedCrypto]}
              </div>
              <button 
                className={`share-button copy ${copySuccess ? 'success' : ''}`}
                onClick={handleCopyAddress}
              >
                {copySuccess ? <><FaCheck /> Copied!</> : 'Copy Address'}
              </button>
            </div>

            <div className="qr-container">
              <QRCodeSVG 
                value={cryptoAddresses[selectedCrypto]}
                size={200}
                level="H"
                includeMargin={true}
                bgColor="transparent"
                fgColor="#2e7d32"
              />
            </div>
          </div>
        ) : (
          <div className="card-payment">
            <div className="input-group">
              <label className="input-label">Card Number</label>
              <input 
                type="text" 
                className="card-input"
                placeholder="1234 5678 9012 3456"
              />
            </div>

            <div className="card-row">
              <div className="input-group">
                <label className="input-label">Expiry Date</label>
                <input 
                  type="text" 
                  className="card-input"
                  placeholder="MM/YY"
                />
              </div>
              <div className="input-group">
                <label className="input-label">CVV</label>
                <input 
                  type="text" 
                  className="card-input"
                  placeholder="123"
                />
              </div>
            </div>

            <button className="convert-button">
              <FaLock /> Pay Securely
            </button>

            <div className="secure-badge">
              <FaLock /> All card information is securely encrypted
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PaymentPage;